import React, { useEffect, useState } from "react";
import CustomSelect from "../../components/CustomSelect/CustomSelect";
import { ThreeRow, TwoColumn, TwoRow } from "../../core/layouts";
import ThreeColumn from "../../core/layouts/ThreeColumn";
import variables from "../../themes/base/styles/variables";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";
import {
  Text,
  Space,
  Switch,
  Input,
  Tag,
  Button,
  Checkbox,
} from "react_reusable_components";
import { useIntl } from "react-intl";
import {
  questionnaireSelectOptions,
  QUESTION_TYPE_CONSTANTS,
} from "../../constants";
import ConfirmModalContainer from "../ConfirmModalContainer/ConfirmModalContainer";
import QuestionStyle from "../AddQuestionnaireQuestionContainer/AddQuestionnaireQuestionContainerStyle.module.scss";
import mainStyles from "../AddQuestionnaireSectionContainer/AddQuestionnaireSectionContainerStyle.module.scss";

const AddQuestionnaireQuestionContentStyle = {
  rightSectionStyle: {
    width: variables.questionRightWidth,
    overflow: "hidden",
  },
  tagStyle: {
    borderRadius: variables.radiusXXLarge,
    lineHeight: variables.lineHeightNormal,
    fontWeight: variables.fontWeightNormal,
    fontSize: variables.fontSizeNormal,
    color: variables.textDefault,
    padding: `${variables.marginXSmallest} ${variables.marginMediumSmall}`,
    height: variables.tagHeight,
    display: variables.dFlex,
    alignItems: variables.alignCenter,
    justifyContent: variables.justifyCenter,
    border: variables.tagBorder,
    background: variables.lightCraftingBlue,
    width: "fit-content",
    textTransform: "capitalize",
    margin: 0,
  },
  deleteIcon: {
    width: variables.iconWidth,
    height: variables.iconHeight,
    cursor: "pointer",
  },
  twoColumnRightSectionStyle: {
    paddingLeft: variables.paddingSmall,
    borderLeft: `1px solid ${variables.grey4}`,
  },
  twoColumnLeftSectionStyle: {
    borderRight: `1px solid ${variables.grey4}`,
    padding: `0 ${variables.paddingSmall}`,
  },
  twoColumnMainStyle: {
    alignItems: "center",
    overflow: "hidden",
    gap: variables.gapSmaller,
  },

  twoRowMiddleSectionStyle: {
    flexDirection: "column",
    gap: variables.gapSmaller,
    marginTop: `${variables.marginMediumSmall}`,
    marginLeft: variables.marginLarge3,
    width: `calc(100% - ${variables.marginLarge3})`,
  },
  optionWrapperStyle: {
    gap: variables.gapSmaller,
    width: variables.fullWidth,
    alignItems: "center",
  },
  crossIconStyle: {
    width: variables.iconWidthLarge,
    height: variables.iconHeightLarge,
    cursor: "pointer",
  },

  bottomSectionStyle: {
    borderTop: `1px solid ${variables.grey4}`,
    paddingTop: variables.paddingSmall,
    marginTop: variables.paddingSmall,
  },
  buttonWrapper: { justifyContent: "space-between", alignItems: "center" },
  dotStyle: {
    width: variables.dot,
    height: variables.dot,
    borderRadius: "50%",
    backgroundColor: variables.textDefault,
  },
};
const AddQuestionnaireQuestionContent = ({
  mode,
  question,
  questionsData,
  setQuestionsData,
  indexKey,
  addQuestionToSection,
  showAddNewSection,
}) => {
  const intl = useIntl();
  const Element = mode === "view" ? Input.TextArea : Input;

  const [modalMessage, setModalMessage] = useState("");
  const [singleQuestionValueItem, setSingleQuestionValueItem] = useState(null);
  const [checked, setChecked] = useState(false);

  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    setChecked(
      question?.questionType?.length > 1 &&
        question?.questionType?.some(
          (item) => item.type === QUESTION_TYPE_CONSTANTS.TEXTBOX
        )
    );
  }, [questionsData]);

  function updateQuestionKeyValuePairs(
    keyToInsert,
    data,
    questionValueSequenceId
  ) {
    const traverseAndUpdateQuestion = (sections, value) => {
      for (const section of sections) {
        if (section.sequence === indexKey) {
          if (section.questions) {
            const foundQuestion = section.questions.find(
              (q) => q.sequence === question.sequence
            );
            if (
              keyToInsert === "questionType" &&
              questionValueSequenceId &&
              foundQuestion.questionType[0]?.questionValue
            ) {
              const questionValueArray =
                foundQuestion.questionType[0].questionValue;
              const foundQuestionTypeWithMatchSequence =
                questionValueArray.find(
                  (item) =>
                    item.sequence === questionValueSequenceId ||
                    item.id === questionValueSequenceId
                );
              if (foundQuestionTypeWithMatchSequence) {
                foundQuestionTypeWithMatchSequence.value = value;
              }
            } else if (keyToInsert === "questionType") {
              foundQuestion[keyToInsert][0] = {
                ...foundQuestion[keyToInsert][0],
                type: value,
              };
              if (!foundQuestion?.questionType[0]?.questionValue?.length) {
                addOptionToQuestion();
                addOptionToQuestion();
              }
            } else if (foundQuestion) {
              foundQuestion[keyToInsert] = value;
            }
            return;
          }
        }

        if (section.sections) {
          traverseAndUpdateQuestion(section.sections, value);
        }
      }
    };

    traverseAndUpdateQuestion(questionsData, data);
    setQuestionsData([...questionsData]);
  }
  function addOptionToQuestion() {
    const traverseAndUpdateQuestion = (sections) => {
      for (const section of sections) {
        if (section.sequence === indexKey) {
          if (section.questions) {
            const foundQuestion = section.questions.find(
              (q) => q.sequence === question.sequence
            );
            if (foundQuestion?.questionType) {
              const questionType = foundQuestion.questionType[0];
              if (!questionType.questionValue) {
                questionType.questionValue = [];
              }
              const lastSequence =
                questionType.questionValue[
                  questionType.questionValue.length - 1
                ]?.sequence || 0;
              questionType.questionValue.push({
                sequence: lastSequence + 1,
              });
            }
            return;
          }
        }

        if (section.sections) {
          traverseAndUpdateQuestion(section.sections);
        }
      }
    };

    traverseAndUpdateQuestion(questionsData);
    setQuestionsData([...questionsData]);
  }
  function handleAllowAdditionalCheckbox(targetSequence) {
    const traverseAndDeleteQuestion = (sections) => {
      for (const section of sections) {
        if (section.questions && section?.sequence === indexKey) {
          const questionIndex = section.questions.findIndex(
            (q) => q.sequence === targetSequence
          );
          if (questionIndex !== -1) {
            const ques = section.questions[questionIndex];
            if (ques.sequence === targetSequence) {
              if (
                !ques?.questionType
                  ?.map((item) => item.type)
                  .includes(QUESTION_TYPE_CONSTANTS.TEXTBOX)
              ) {
                if (!ques.questionType) {
                  ques.questionType = [];
                }
                ques.questionType.push({
                  type: QUESTION_TYPE_CONSTANTS.TEXTBOX,
                });
              } else {
                if (ques.questionType) {
                  ques.questionType = ques.questionType.filter(
                    (type) => type.type !== QUESTION_TYPE_CONSTANTS.TEXTBOX
                  );
                }
              }
            }
            return; // Exit the function after deleting the question or option
          }
        }

        if (section.sections) {
          traverseAndDeleteQuestion(section.sections);
        }
      }
    };

    traverseAndDeleteQuestion(questionsData);
    setQuestionsData([...questionsData]);
  }

  function deleteQuestion(questionId, questionValueSequenceId) {
    const traverseAndDeleteQuestion = (sections) => {
      for (const section of sections) {
        if (section.questions && section?.sequence === indexKey) {
          const questionIndex = section.questions.findIndex(
            (q) => q.sequence === questionId
          );
          if (questionIndex !== -1) {
            const foundQuestion = section.questions[questionIndex];
            if (questionValueSequenceId) {
              const questionValueArray =
                foundQuestion.questionType[0]?.questionValue;
              if (questionValueArray) {
                const optionIndex = questionValueArray.findIndex(
                  (item) =>
                    item.sequence === questionValueSequenceId ||
                    item.id === questionValueSequenceId
                );
                if (optionIndex !== -1) {
                  questionValueArray.splice(optionIndex, 1);
                  for (
                    let i = optionIndex;
                    i < questionValueArray.length;
                    i++
                  ) {
                    questionValueArray[i].sequence = i + 1;
                  }
                }
              }
            } else {
              section.questions.splice(questionIndex, 1);

              for (let i = questionIndex; i < section.questions.length; i++) {
                section.questions[i].sequence = i + 1;
              }

              return;
            }
            return; // Exit the function after deleting the question or option
          }
        }

        if (section.sections) {
          traverseAndDeleteQuestion(section.sections);
        }
      }
    };

    traverseAndDeleteQuestion(questionsData);
    setQuestionsData([...questionsData]);
  }

  return (
    <>
      <ThreeRow
        topSection={
          <TwoColumn
            style={{
              gap: variables.gapSmaller,
              ...(mode !== "view" && {
                alignItems: variables.alignCenter,
              }),
            }}
            leftSectionStyle={{
              flex: 1,
              ...(mode === "view" && {
                justifyContent: "center",
              }),
            }}
            leftSection={
              <div style={{ display: variables.dFlex }}>
                {mode === "view" && (
                  <Text
                    type="secondary"
                    className={QuestionStyle["section-index-heading-style"]}
                    onClick={(e) => e.stopPropagation()}
                    style={{ lineHeight: variables.lineHeightXlarge }}
                  >
                    {String.fromCharCode(96 + question.sequence)}.
                  </Text>
                )}
                <Element
                  disabled={mode === "view"}
                  autoSize={{ minRows: 1, maxRows: 10 }}
                  prefix={
                    <Text
                      className={QuestionStyle["section-index-heading-style"]}
                    >
                      {String.fromCharCode(96 + question.sequence)}.
                    </Text>
                  }
                  className={QuestionStyle["name-input-style"]}
                  placeholder={
                    mode !== "view" &&
                    getLocalizedMessage(
                      intl,
                      "manageQuestionnaire.questionPlaceholder"
                    )
                  }
                  onChange={(e) => {
                    updateQuestionKeyValuePairs("name", e.target.value);
                  }}
                  value={question.name}
                />
              </div>
            }
            /** Uncomment this to revive question type functionality */

            // rightSectionStyle={{
            //   ...AddQuestionnaireQuestionContentStyle.rightSectionStyle,
            //   ...(mode === "view" && {
            //     width: "fit-content",
            //   }),
            // }}
            // rightSection={
            //   mode === "view" ? (
            //     <Tag style={AddQuestionnaireQuestionContentStyle.tagStyle}>
            //       {
            //         questionnaireSelectOptions.filter(
            //           (item) => item.value === question?.questionType?.[0].type
            //         )[0].label
            //       }
            //     </Tag>
            //   ) : (
            //     <CustomSelect
            //       showSearch={false}
            //       type="selectDropdown"
            //       value={question?.questionType?.[0]?.type}
            //       placeholder={getLocalizedMessage(
            //         intl,
            //         "manageQuestionnaire.questionTypePlaceholder"
            //       )}
            //       onChange={(value) => {
            //         updateQuestionKeyValuePairs("questionType", value);
            //       }}
            //       options={questionnaireSelectOptions?.map((option) => {
            //         return {
            //           label: (
            //             <Text
            //               className={`${QuestionStyle["select-dropdown-item-style"]}`}
            //             >
            //               {option.label}
            //             </Text>
            //           ),
            //           value: option.value,
            //         };
            //       })}
            //     ></CustomSelect>
            //   )
            // }
          />
        }
        middleSection={
          <TwoRow
            topSectionStyle={{
              ...(question?.questionType?.[0]?.type !==
                QUESTION_TYPE_CONSTANTS.TEXTBOX &&
                question?.questionType?.[0]?.questionValue?.length &&
                AddQuestionnaireQuestionContentStyle.twoRowMiddleSectionStyle),
              ...(mode === "view" &&
                question?.questionType?.[0]?.type !==
                  QUESTION_TYPE_CONSTANTS.TEXTBOX && {
                  marginTop: variables.marginSmallest,
                }),
            }}
            topSection={
              question?.questionType?.[0]?.type !==
                QUESTION_TYPE_CONSTANTS.TEXTBOX &&
              question?.questionType?.[0]?.questionValue?.map(
                (questionValueItem, index) => {
                  return (
                    <TwoColumn
                      style={
                        AddQuestionnaireQuestionContentStyle.optionWrapperStyle
                      }
                      key={questionValueItem.sequence}
                      leftSectionStyle={{
                        flex: 1,
                      }}
                      leftSection={
                        <div style={{ display: variables.dFlex }}>
                          {mode === "view" && (
                            <div
                              className={
                                QuestionStyle["section-index-heading-style"]
                              }
                              style={{
                                ...AddQuestionnaireQuestionContentStyle.dotStyle,
                                ...(mode === "view" && {
                                  marginTop: variables.marginHalf,
                                }),
                              }}
                            ></div>
                          )}
                          <Element
                            disabled={mode === "view"}
                            autoSize={{ minRows: 1, maxRows: 10 }}
                            prefix={
                              <Text
                                className={
                                  QuestionStyle["section-index-heading-style"]
                                }
                                style={
                                  AddQuestionnaireQuestionContentStyle.dotStyle
                                }
                              ></Text>
                            }
                            className={QuestionStyle["name-input-style"]}
                            placeholder={`${getLocalizedMessage(
                              intl,
                              "manageQuestionnaire.optionPlaceholder"
                            )} ${index + 1}`}
                            onChange={(e) => {
                              updateQuestionKeyValuePairs(
                                "questionType",
                                e.target.value,
                                questionValueItem.sequence ||
                                  questionValueItem.id
                              );
                            }}
                            value={questionValueItem?.value}
                          />
                        </div>
                      }
                      rightSectionStyle={{
                        ...(mode !== "view" && {
                          width: variables.questionRightWidth,
                        }),
                      }}
                      rightSection={
                        mode !== "view" && (
                          <img
                            style={
                              AddQuestionnaireQuestionContentStyle.crossIconStyle
                            }
                            alt="crossIcon"
                            src={"/icons/close.svg"}
                            onClick={() => {
                              setModalMessage(
                                getLocalizedMessage(
                                  intl,
                                  "manageQuestionnaire.deleteOption",
                                  {
                                    name: questionValueItem.value
                                      ? `"${questionValueItem.value}"`
                                      : "this",
                                  }
                                )
                              );
                              setSingleQuestionValueItem(questionValueItem);
                              setOpenModal(true);
                            }}
                          />
                        )
                      }
                    />
                  );
                }
              )
            }
            bottomSectionStyle={{
              ...(mode !== "view" && {
                marginTop: variables.marginMediumSmall,
                marginLeft: variables.marginMediumSmall,
              }),
            }}
            bottomSection={
              question?.questionType?.some(
                (item) =>
                  item.type === QUESTION_TYPE_CONSTANTS.SINGLE_SELECT ||
                  item.type === QUESTION_TYPE_CONSTANTS.MULTI_SELECT
              ) &&
              mode !== "view" && (
                <Text
                  className={QuestionStyle["text-label"]}
                  style={{
                    color: variables.primaryBg,
                    cursor: "pointer",
                    margin: `0 ${variables.marginMediumSmall}`,
                  }}
                  onClick={addOptionToQuestion}
                >
                  {getLocalizedMessage(intl, "manageQuestionnaire.addOption")}
                </Text>
              )
            }
          />
        }
        bottomSectionStyle={{
          ...((mode !== "view" || question?.isMandatory || checked) &&
            AddQuestionnaireQuestionContentStyle.bottomSectionStyle),
        }}
        bottomSection={
          <TwoColumn
            style={AddQuestionnaireQuestionContentStyle.buttonWrapper}
            leftSection={
              mode !== "view" &&
              showAddNewSection && (
                <Button
                  style={{ marginBottom: 0 }}
                  className={mainStyles["add-new-section"]}
                  ghost
                  icon={null}
                  onClick={(e) => {
                    addQuestionToSection(questionsData, indexKey, question);
                  }}
                >
                  <img
                    alt={"icon"}
                    src="/icons/add.svg"
                    className={mainStyles["icon"]}
                  />
                  {getLocalizedMessage(
                    intl,
                    "manageQuestionnaire.addNewQuestion"
                  )}
                </Button>
              )
            }
            rightSection={
              <ThreeColumn
                style={AddQuestionnaireQuestionContentStyle.twoColumnMainStyle}
                leftSectionStyle={{
                  ...((mode !== "view" || (question?.isMandatory && checked)) &&
                    AddQuestionnaireQuestionContentStyle.twoColumnLeftSectionStyle),
                }}
                leftSection={
                  ((mode !== "view" &&
                    question?.questionType?.some(
                      (item) =>
                        item.type === QUESTION_TYPE_CONSTANTS.SINGLE_SELECT ||
                        item.type === QUESTION_TYPE_CONSTANTS.MULTI_SELECT
                    )) ||
                    (mode === "view" && checked)) && (
                    <Checkbox
                      disabled={mode === "view"}
                      onChange={() =>
                        handleAllowAdditionalCheckbox(question?.sequence)
                      }
                      checked={checked}
                      text={
                        <Text
                          className={QuestionStyle["text-label"]}
                          type="secondary"
                        >
                          {getLocalizedMessage(
                            intl,
                            "manageQuestionnaire.allowAdditionTextbox"
                          )}
                        </Text>
                      }
                    />
                  )
                }
                middleSection={
                  mode !== "view" && (
                    <img
                      style={AddQuestionnaireQuestionContentStyle.deleteIcon}
                      src="/icons/delete.svg"
                      alt="delete"
                      onClick={() => {
                        setModalMessage(
                          getLocalizedMessage(
                            intl,
                            "manageQuestionnaire.deleteQuestion",
                            {
                              name: question.name
                                ? `"${question.name}"`
                                : "this",
                            }
                          )
                        );
                        setOpenModal(true);
                      }}
                    />
                  )
                }
                middleSectionStyle={{
                  ...(mode === "view" && { display: "none" }),
                }}
                rightSectionStyle={{
                  ...(mode !== "view" &&
                    AddQuestionnaireQuestionContentStyle.twoColumnRightSectionStyle),
                  ...(mode === "view" &&
                    !question?.isMandatory && { display: "none" }),
                }}
                rightSection={
                  (mode !== "view" || question?.isMandatory) && (
                    <Space size={0}>
                      <Text
                        type="secondary"
                        className={QuestionStyle["text-label"]}
                      >
                        {getLocalizedMessage(
                          intl,
                          "manageQuestionnaire.mandatory"
                        )}
                      </Text>
                      <Switch
                        disabled={mode === "view"}
                        onChange={(checkedValue) => {
                          updateQuestionKeyValuePairs(
                            "isMandatory",
                            checkedValue
                          );
                        }}
                        style={{
                          marginLeft: variables.marginMediumSmall,
                        }}
                        size="medium"
                        checked={question.isMandatory}
                      />
                    </Space>
                  )
                }
              />
            }
          />
        }
      />
      <ConfirmModalContainer
        open={openModal}
        setOpen={setOpenModal}
        question={modalMessage}
        iconSrc={"/icons/warningIcon.svg"}
        onConfirm={() => {
          singleQuestionValueItem
            ? deleteQuestion(
                question?.sequence,
                singleQuestionValueItem?.sequence || singleQuestionValueItem?.id
              )
            : deleteQuestion(question?.sequence);
          setOpenModal(false);
        }}
      />
    </>
  );
};

export default AddQuestionnaireQuestionContent;
